import { Layout, Typography } from 'antd';
import { Content, Footer } from 'antd/es/layout/layout';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGAPageTracking } from '../../hooks/useGAPageTracking';
import { Suspense } from 'react';
import { Loading } from '../components/common/Loading';
import ErrorBoundary from '../components/common/ErrorBoundary';

export const GuestLayout = () => {
  const { t } = useTranslation();
  useGAPageTracking();
  return (
    <Layout
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <ScrollRestoration />
      <Layout>
        <Content
          style={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#F5FAFF',
          }}
        >
          <ErrorBoundary>
            <Suspense fallback={<Loading />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </Content>
      </Layout>
      <Footer style={{ textAlign: 'center' }}>
        {t('footer.copyright')}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <a
            href="https://www.ohat.jp/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"
            target="_blank"
            rel="noreferrer"
          >
            <Typography.Text
              style={{
                paddingTop: 4,
                fontSize: 14,
                textAlign: 'center',
                textDecorationLine: 'underline',
              }}
            >
              {t('footer.terms')}
            </Typography.Text>
          </a>
          <a
            href="https://medi-banx.com/privacy/"
            target="_blank"
            rel="noreferrer"
          >
            <Typography.Text
              style={{
                paddingTop: 4,
                fontSize: 14,
                textAlign: 'center',
                textDecorationLine: 'underline',
              }}
            >
              {t('footer.privacy')}
            </Typography.Text>
          </a>
          <a
            href="https://medi-banx.com/contact/"
            target="_blank"
            rel="noreferrer"
          >
            <Typography.Text
              style={{
                paddingTop: 4,
                fontSize: 14,
                textAlign: 'center',
                textDecorationLine: 'underline',
              }}
            >
              {t('footer.contact')}
            </Typography.Text>
          </a>
        </div>
      </Footer>
    </Layout>
  );
};
